export function GenerateExecuteRequest(message, reqFormatter, respFormatter) {
    return {
        message,
        requestFormatter: reqFormatter,
        responseFormatter: respFormatter,
    };
}
//# sourceMappingURL=GenerateExecuteRequest.js.map